module.exports = require("@material-ui/icons/CancelOutlined");